import { error as p } from "../../_utils/naive/warn.js";
import { isBrowser as w } from "../../_utils/env/is-browser.js";
var d = globalThis && globalThis.__awaiter || function(e, n, i, o) {
  function c(t) {
    return t instanceof i ? t : new i(function(r) {
      r(t);
    });
  }
  return new (i || (i = Promise))(function(t, r) {
    function l(s) {
      try {
        a(o.next(s));
      } catch (f) {
        r(f);
      }
    }
    function u(s) {
      try {
        a(o.throw(s));
      } catch (f) {
        r(f);
      }
    }
    function a(s) {
      s.done ? t(s.value) : c(s.value).then(l, u);
    }
    a((o = o.apply(e, n || [])).next());
  });
};
function m(e) {
  return e.includes("image/");
}
function h(e = "") {
  const n = e.split("/"), o = n[n.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(o) || [""])[0];
}
const y = /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i, E = (e) => {
  if (e.type)
    return m(e.type);
  const n = h(e.name || "");
  if (y.test(n))
    return !0;
  const i = e.thumbnailUrl || e.url || "", o = h(i);
  return !!(/^data:image\//.test(i) || y.test(o));
};
function x(e) {
  return d(this, void 0, void 0, function* () {
    return yield new Promise((n) => {
      if (!e.type || !m(e.type)) {
        n("");
        return;
      }
      n(window.URL.createObjectURL(e));
    });
  });
}
const L = w && window.FileReader && window.File;
function g(e) {
  return e.isDirectory;
}
function v(e) {
  return e.isFile;
}
function I(e, n) {
  return d(this, void 0, void 0, function* () {
    const i = [];
    function o(c) {
      return d(this, void 0, void 0, function* () {
        for (const t of c)
          if (t) {
            if (n && g(t)) {
              const r = t.createReader();
              let l = [], u;
              try {
                do
                  u = yield new Promise((a, s) => {
                    r.readEntries(a, s);
                  }), l = l.concat(u);
                while (u.length > 0);
              } catch (a) {
                p("upload", "error happens when handling directory upload", a);
              }
              yield o(l);
            } else if (v(t))
              try {
                const r = yield new Promise((l, u) => {
                  t.file(l, u);
                });
                i.push({
                  file: r,
                  entry: t,
                  source: "dnd"
                });
              } catch (r) {
                p("upload", "error happens when handling file upload", r);
              }
          }
      });
    }
    return yield o(e), i;
  });
}
function R(e) {
  const {
    id: n,
    name: i,
    percentage: o,
    status: c,
    url: t,
    file: r,
    thumbnailUrl: l,
    type: u,
    fullPath: a,
    batchId: s
  } = e;
  return {
    id: n,
    name: i,
    percentage: o != null ? o : null,
    status: c,
    url: t != null ? t : null,
    file: r != null ? r : null,
    thumbnailUrl: l != null ? l : null,
    type: u != null ? u : null,
    fullPath: a != null ? a : null,
    batchId: s != null ? s : null
  };
}
function S(e, n, i) {
  return e = e.toLowerCase(), n = n.toLocaleLowerCase(), i = i.toLocaleLowerCase(), i.split(",").map((c) => c.trim()).filter(Boolean).some((c) => {
    if (c.startsWith(".")) {
      if (e.endsWith(c))
        return !0;
    } else if (c.includes("/")) {
      const [t, r] = n.split("/"), [l, u] = c.split("/");
      if ((l === "*" || t && l && l === t) && (u === "*" || r && u && u === r))
        return !0;
    } else
      return !0;
    return !1;
  });
}
export {
  x as createImageDataUrl,
  R as createSettledFileInfo,
  L as environmentSupportFile,
  I as getFilesFromEntries,
  g as isFileSystemDirectoryEntry,
  v as isFileSystemFileEntry,
  E as isImageFile,
  m as isImageFileType,
  S as matchType
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/utils.js
// module id = 497
// module chunks = 67